import { render, staticRenderFns } from "./AppFilterSectionUserProperty.vue?vue&type=template&id=f72b81c0&scoped=true"
import script from "./AppFilterSectionUserProperty.vue?vue&type=script&lang=js"
export * from "./AppFilterSectionUserProperty.vue?vue&type=script&lang=js"
import style0 from "./AppFilterSectionUserProperty.vue?vue&type=style&index=0&id=f72b81c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72b81c0",
  null
  
)

export default component.exports